import { render, staticRenderFns } from "./platOrder.vue?vue&type=template&id=31a0a57a&scoped=true"
import script from "./platOrder.vue?vue&type=script&lang=js"
export * from "./platOrder.vue?vue&type=script&lang=js"
import style0 from "./platOrder.vue?vue&type=style&index=0&id=31a0a57a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a0a57a",
  null
  
)

export default component.exports